import { select } from 'redux-saga/effects';

import { getAuthUser } from '../../selectors';

const validateUser = function* validateUser() {
  const authUser = yield select(getAuthUser);

  if (!authUser || !authUser.uid) {
    throw 'Cannot create or update event without being signed in';
  }

  return authUser;
};

export { validateUser };



// WEBPACK FOOTER //
// ./src/redux/sagas/events/utils/auth.js